import _ from 'lodash'
import siteHeaderConfig from './config'
import { gsap } from 'gsap'

class SiteHeaderClass {
    constructor() {
        this.DOM = {
            el: siteHeaderConfig.el,
            subnavTriggers: siteHeaderConfig.subnavTriggers,
            subnavs: siteHeaderConfig.subnavs,
            subnavHamburger: siteHeaderConfig.subnavHamburger,
            mobileHamburger: siteHeaderConfig.mobileHamburger,
            main: siteHeaderConfig.main,
            subnavBusiness: null
        }
        this.treshold = siteHeaderConfig.treshold,
        this.breakpoint = siteHeaderConfig.breakpoint
        this.direction = 1024
        this.y = window.scrollY
        this.subnavTop = 125
        
        this.subnavState = false
        this.subnavActive = null

        this.businessStateNav = true
        this.mobileState = false

        this.isTransparent = false

        this.top = 0

        this.init()
    }
    init() {
        this._isBusiness()
        this._isTransparent()
        this._calcTop()
        this._listeners()
        this._scrollPosition()
    }

    _listeners() {
        window.innerWidth > this.breakpoint ? this._headerDesktop() : null
        window.innerWidth >= this.breakpoint ? this._subnavBusinessHamburger() : null 
       this._mobileHamburger()
    }

    _isBusiness() {
        this.DOM.subnavBusiness = _.select( '.header__main .nav__business' )
    }

    _isTransparent() {
        const body = _.select( 'body' )
        this.isTransparent = _.containClass( body, 'is-header-transparent' ) ? true : false
    }

    _calcTop() {
        if ( window.innerWidth >= this.breakpoint ) {
            this.top = this.DOM.subnavBusiness ? this.DOM.el.clientHeight + this.DOM.subnavBusiness.clientHeight : this.DOM.el.clientHeight
        }
    }


    // Header animations on scroll
    _headerDesktop() {
        this._scrollListener()
    } 
    _scrollListener() {
        window.addEventListener( 'scroll', this._scrollPosition.bind( this ) )
    }
    _scrollPosition( event ) {
        window.scrollY > this.y ? this.direction = 'down' : this.direction = 'up'
        this.y = window.scrollY

        this._headerVisibility()
        this.isTransparent ? this._headerTransparentize() : null
    }
    _headerVisibility() {
        this.direction == 'down' && this.y > this.treshold ? this._headerHide() : this._headerShow() 
    }

    _headerTransparentize() {
        this.direction == 'up' && this.y > this.treshold ? _.removeClass( this.DOM.el, 'header__main--business-transparent' ) : _.addClass( this.DOM.el, 'header__main--business-transparent' )
    }

    _headerHide() {
        gsap.to( this.DOM.el, {
            top: -this.top,
            duration: .4
        })
        /*
        gsap.to( this.DOM.subnavs, {
            top: -this.top,
            duration: .4
        })
        */
        
    } 
    _headerShow() {
        gsap.to( this.DOM.el, {
            top: 0,
            duration: .4
        })
        /*
        gsap.to( this.DOM.subnavs, {
            top: this.top,
            duration: .4
        })
        */
        
    }

    // Subnav display
    _subnavListener() {
        this.DOM.subnavTriggers.forEach( ( trigger ) => { trigger.addEventListener( 'mouseenter', this._subnavState.bind( this ) )})
    }
    _subnavState() {
        !this.subnavState ? this._subnavShow() : this._subnavHide()
        this.subnavState = !this.subnavState
    }
    _subnavShow() {
        let target = event.target,
            id = target.getAttribute( 'data-subnav' ),
            subnav = _.select( `.header__main .subnav[data-subnav="${id}"]` )
        
        this.subnavActive = id
        
        _.addClass( target, 'is--active' )
        _.addClass( subnav, 'is--active' )

        _.selectAll( '*:not(.subnav--leaver)' ).forEach( ( item ) => { item.addEventListener( 'mouseenter', this._subnavHide.bind( this ) ) })
    }
    _subnavHide() {
        _.removeClass( `.header__main .subnav__trigger[data-subnav="${this.subnavActive}"]`, 'is--active' )
        _.removeClass( `.header__main .subnav[data-subnav="${this.subnavActive}"]`, 'is--active' )

        this.subnavActive = null
    }

    // Business hamburguer
    _subnavBusinessHamburger() {
        this.DOM.subnavHamburger.addEventListener( 'click', this._subnavBusinessState.bind( this ) )
    }
    _subnavBusinessState() {
        this.businessStateNav ? this._subnavBusinessHide() : this._subnavBusinessShow()
        this.businessStateNav = !this.businessStateNav
    }
    _subnavBusinessHide() {
        _.removeClass( this.DOM.el, 'header__main--business' )
        _.addClass( this.DOM.el, 'header__main--mainnav' )
    }
    _subnavBusinessShow() {
        _.addClass( this.DOM.el, 'header__main--business' )
        _.removeClass( this.DOM.el, 'header__main--mainnav' )
    }

    // Mobile hamburguer
    _mobileHamburger() {
        this.DOM.mobileHamburger.addEventListener( 'click', this._mobileState.bind( this ) )
    }
    _mobileState() {
        this.mobileState ? this._mobileHide() : this._mobileShow()
        this.mobileState = !this.mobileState
    }
    _mobileHide() {
        _.removeClass( this.DOM.el, 'header__main--mobile' )
    }
    _mobileShow() {
        _.addClass( this.DOM.el, 'header__main--mobile' )
    }
}

const SITE_HEADER = new SiteHeaderClass()
export default SITE_HEADER